import { useMutation } from '@tanstack/react-query'

import { CreateCadastrarClienteService } from '@/http/post-cadastrar-cliente.service'
import type { AxiosErrorMap } from '@/infra/http'
import type { TCreateCadastrarClienteData, TCreateCadastrarClienteResponse } from '@/types/cliente'
import { cadastrarClienteKeys } from '@/utils/clientes-query-keys'

export const useMutationCadastrarCliente = () => {
  return useMutation<TCreateCadastrarClienteResponse, AxiosErrorMap, Partial<TCreateCadastrarClienteData>>({
    mutationKey: cadastrarClienteKeys.cadastrar(),
    mutationFn: async (cadastro: Partial<TCreateCadastrarClienteData>) => {
      const response = await new CreateCadastrarClienteService().execute(cadastro)
      return response.data
    },
  })
}
